/**
 * Admin console access (client-side gate only — not a substitute for server-side auth).
 * Requires ALLOWED_ADMIN_USER_ID when logged in, plus ADMIN_PASSWORD.
 */
import { isSupabaseBackend } from "../services/config";

export const ADMIN_PASSWORD =
  process.env.REACT_APP_ADMIN_PASSWORD || "PayinapoAdmin2026!";

/** Only this logged-in user may open the admin console and call admin APIs */
export const ALLOWED_ADMIN_USER_ID =
  process.env.REACT_APP_ADMIN_USER_ID || "109028678539488325295";

export const ADMIN_SESSION_KEY = "payinapo_admin_unlocked";
export const ADMIN_SCOPE_USER_KEY = "payinapo_admin_scope_user_id";
/** Re-enter admin password after this idle period (ms) */
export const ADMIN_SESSION_MS = 30 * 60 * 1000;

export function getLoggedInUserId() {
  if (typeof localStorage === "undefined") return "";
  try {
    const raw = localStorage.getItem("user");
    if (raw) {
      const u = JSON.parse(raw);
      if (u?.id != null && u.id !== "") return String(u.id).trim();
    }
  } catch {
    /* ignore */
  }
  const legacy = localStorage.getItem("userId");
  return legacy ? String(legacy).trim() : "";
}

export function isAllowedAdminUser() {
  const id = getLoggedInUserId();
  if (id === "" || id !== ALLOWED_ADMIN_USER_ID) return false;

  if (isSupabaseBackend()) {
    try {
      const raw = localStorage.getItem("user");
      if (raw) {
        const u = JSON.parse(raw);
        if (u?.role === "admin") return true;
      }
    } catch {
      /* ignore */
    }
  }

  return true;
}

export function isAdminSessionValid() {
  if (!isAllowedAdminUser()) return false;
  if (typeof sessionStorage === "undefined") return false;
  try {
    const raw = sessionStorage.getItem(ADMIN_SESSION_KEY);
    if (!raw) return false;
    const { at } = JSON.parse(raw);
    return Date.now() - at < ADMIN_SESSION_MS;
  } catch {
    return false;
  }
}

export function setAdminSession() {
  if (!isAllowedAdminUser()) return;
  sessionStorage.setItem(
    ADMIN_SESSION_KEY,
    JSON.stringify({ at: Date.now() })
  );
  sessionStorage.setItem(ADMIN_SCOPE_USER_KEY, ALLOWED_ADMIN_USER_ID);
}

export function clearAdminSession() {
  sessionStorage.removeItem(ADMIN_SESSION_KEY);
  sessionStorage.removeItem(ADMIN_SCOPE_USER_KEY);
}

export function getAdminScopeUserId() {
  if (!isAllowedAdminUser()) return "";
  if (typeof sessionStorage === "undefined") return "";
  return sessionStorage.getItem(ADMIN_SCOPE_USER_KEY) || ALLOWED_ADMIN_USER_ID;
}

export function verifyAdminPassword(input) {
  return (input ?? "").trim() === ADMIN_PASSWORD;
}
